import { ToastSeverity } from 'constants/enums/ToastSeverityEnum'

const alertTitleTextMap = {
	submitIdea: {
		title: 'Ideas submitted successfully!',
		text: 'Play again with a new scenario.',
	},
	submitIdeaError: {
		title: 'Uh oh, error submitting your ideas',
		text: "This isn't your fault, try again later",
	},
	deleteIdea: {
		title: 'Idea has been deleted!',
		text: '',
	},
	editIdea: {
		title: 'Idea has been updated!',
		text: '',
	},
	genAiError: {
		title: 'Whoops, error generating a scenario',
		text: 'GenAI can be finicky, please try again',
	},
	createGame: {
		title: 'Game Successfully Created',
		text: '',
	},
	deleteGame: {
		title: 'game deleted.',
		text: '',
	},
	deleteUser: {
		title: 'We have received your account deletion request',
		text: '',
	},
	deleteUserError: {
		title: 'error processing deletion request',
		text: 'check with administrator',
	},
	updateGame: {
		title: 'game updated.',
		text: '',
	},
	copyGameLink: {
		title: 'Game link copied.',
		text: '',
	},
	sendGameInvite: {
		title: 'Email invitation(s) successfully sent',
		text: '',
	},
	resetPassword: {
		title: 'Password was reset successfully',
		text: '',
	},
	editPrompt: {
		title: 'GenAI prompt updated!',
		text: '',
	},
	updateUser: {
		title: 'Changes successfully changed',
		text: '',
	},
	defaultError: {
		title: `This feature isn't working right now`,
		text: 'Please try again later.',
	},
	copyResponse: {
		title: 'Response copied to your clipboard',
		text: '',
	},
	scenarioGenerated: {
		title: 'Scenario generated successfully!',
		text: 'Your facilitation scenario is ready.',
	},
	personaEdited: {
		title: 'Persona updated successfully!',
		text: 'Your changes have been saved.',
	},
	exampleIdeasRegenerated: {
		title: 'Example ideas updated!',
		text: 'New example ideas have been generated for your personas.',
	},
	imageGenerated: {
		title: 'Image generated successfully!',
		text: 'Your visual aid is ready to use.',
	},
	scenarioGenerationError: {
		title: 'Failed to generate scenario',
		text: 'Unable to create your facilitation scenario. Please try again.',
	},
	personaEditError: {
		title: 'Failed to save persona changes',
		text: 'Your changes could not be saved. Please try again.',
	},
	exampleIdeasRegenerationError: {
		title: 'Failed to regenerate example ideas',
		text: 'Unable to update example ideas. Please try again.',
	},
	imageGenerationError: {
		title: 'Failed to generate image',
		text: 'Unable to create visual aid. Please try again.',
	},
	validationError: {
		title: 'Invalid input',
		text: 'Please check your input and try again.',
	},
}

const defaultErrorMessage = {
	bodyText: alertTitleTextMap.defaultError.text,
	severity: ToastSeverity.ERROR,
	title: alertTitleTextMap.defaultError.title,
}

export { alertTitleTextMap, defaultErrorMessage }
